import { makeStyles, TextField } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const useStyles = makeStyles({
  root: {
    '&.warning fieldset': {
      borderColor: '#ff9234',
    },
    '&.warning > p, &.warning > label': {
      color: '#ff9234',
    },
    // '& .MuiOutlinedInput-root': {
    //   '& fieldset': {
    //     borderColor: '#707070',
    //   },
    // },
  },
});

function TextInputPure({
  id,
  label,
  type,
  onChange,
  onBlur,
  className,
  multiline,
  fullWidth = true,
  InputProps,
  maxLength,
  replace,
  pattern,
  rows,
  disabled = false,
  autoFocus,
  value,
  required,
  error,
  touched,
  getInputRef,
  onFocus,
  onClick,
  onKeyDown,
  warning,
  placeholder,
}) {
  const hasError = error && touched;
  const helper = warning || (hasError ? error : undefined);
  const ref = useRef(null);

  const styles = useStyles();

  const getRef = () => {
    if (getInputRef) {
      return getInputRef();
    }
    return ref;
  };
  const inputRef = getRef();

  useEffect(() => {
    if (autoFocus) {
      inputRef.current.focus();
    }
  }, [inputRef, autoFocus]);

  return (
    <TextField
      placeholder={placeholder}
      inputRef={inputRef}
      required={!!required}
      className={clsx(styles.root, warning && 'warning', className)}
      id={id}
      name={id}
      label={label}
      onChange={(event) => {
        if (onChange) {
          if (replace && event.target.value) {
            event.target.value = event.target.value.replace(replace.searchValue, replace.newValue);
          }
          if (pattern && event.target.value && !pattern.test(event.target.value)) {
            return;
          }
          if (maxLength && event.target.value.length > maxLength) {
            event.target.value = event.target.value.substr(0, maxLength);
          }
          if (event.target.value) {
            event.target.value = event.target.value.trimStart();
          }
          onChange(event);
        }
      }}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onClick={onClick}
      onBlur={onBlur}
      value={value === undefined ? '' : value}
      fullWidth={fullWidth}
      multiline={multiline}
      rows={rows}
      variant="outlined"
      type={type}
      error={Boolean(hasError)}
      helperText={helper}
      InputLabelProps={{ shrink: true }}
      InputProps={InputProps}
      disabled={disabled}
      autoFocus={autoFocus}
      autoComplete="off"
      inputProps={{
        autoComplete: 'off',
      }}
      size="medium"
    />
  );
}

TextInputPure.propTypes = {
  replace: PropTypes.shape({
    searchValue: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]),
    newValue: PropTypes.string,
  }),
};

function areEqual(prevProps, nextProps) {
  const {
    value: prevValue,
    required: prevRequired,
    error: prevError,
    touched: prevTouched,
    disabled: prevDisabled,
    warning: prevWarning,
  } = prevProps;
  const { value, required, error, touched, disabled, warning } = nextProps;

  const isEqual =
    value === prevValue &&
    required === prevRequired &&
    error === prevError &&
    touched === prevTouched &&
    disabled === prevDisabled &&
    warning === prevWarning;

  return isEqual;
}

const TextInput = React.memo(TextInputPure, areEqual);

TextInput.defaultProps = {
  onFocus: () => {},
  onClick: () => {},
  onKeyDown: () => {},
};

export default TextInput;
